// extracted by mini-css-extract-plugin
module.exports = {"ariaSkipLinksContainer":"Ej-z"};